import {CdoCustomerRequirement} from '../../interfaces/customer-documents/cdo-customer-requirement';
import {CdoIntervalUnit} from '../../enums/customer-documents/cdo-interval-unit.enum';
import {CdoIntervalMode} from '../../enums/customer-documents/cdo-interval-mode.enum';

export class CdoCustomerRequirementFactory {

  /**
   *
   * @param cdoCustomerRequirement
   */
  public static fromObject(cdoCustomerRequirement: any): CdoCustomerRequirement {
    return new class implements CdoCustomerRequirement {
      customerId: number = cdoCustomerRequirement.customer_id ?? cdoCustomerRequirement.customerId;
      cdoDocumentTypeId: number =
        cdoCustomerRequirement.cdo_document_type_id ?? cdoCustomerRequirement.cdoDocumentTypeId;
      requiredCount: number = cdoCustomerRequirement.required_count ?? cdoCustomerRequirement.requiredCount;
      intervalUnit: CdoIntervalUnit =
        cdoCustomerRequirement.interval_unit ?? cdoCustomerRequirement.intervalUnit ?? null;
      intervalMode: CdoIntervalMode =
        cdoCustomerRequirement.interval_mode ?? cdoCustomerRequirement.intervalMode ?? null;
      comment: string = cdoCustomerRequirement.comment ?? null;
      userId: number = cdoCustomerRequirement.user_id ?? cdoCustomerRequirement.userId;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = cdoCustomerRequirement.id;
      uuid: string = cdoCustomerRequirement.uuid;
      modified: string = cdoCustomerRequirement.modified;
      created: string = cdoCustomerRequirement.created;
    };
  }

  /**
   *
   * @param cdoCustomerRequirements
   */
  public static fromArray(cdoCustomerRequirements: any[]): CdoCustomerRequirement[] {
    return cdoCustomerRequirements.map(_cdoCustomerRequirement => this.fromObject(_cdoCustomerRequirement));
  }

  /**
   *
   * @param cdoCustomerRequirement
   */
  public static toRemote(cdoCustomerRequirement: CdoCustomerRequirement): any {
    return {
      customer_id: cdoCustomerRequirement.customerId,
      cdo_document_type_id: cdoCustomerRequirement.cdoDocumentTypeId,
      required_count: cdoCustomerRequirement.requiredCount,
      interval_unit: cdoCustomerRequirement.intervalUnit,
      interval_mode: cdoCustomerRequirement.intervalMode,
      comment: cdoCustomerRequirement.comment ?? null
    };
  }

  /**
   *
   * @param cdoCustomerRequirement
   */
  public static new(cdoCustomerRequirement: Partial<CdoCustomerRequirement> = {}): CdoCustomerRequirement {
    const newCdoCustomerRequirement: CdoCustomerRequirement = new class implements CdoCustomerRequirement {
      customerId: number = null;
      cdoDocumentTypeId: number = null;
      requiredCount: number = 1;
      intervalUnit: CdoIntervalUnit = null;
      intervalMode: CdoIntervalMode = null;
      comment: string = null;
      userId: number = null;

      // ---------------------------------------------------------------------------------------------------------------
      id: number = null;
      uuid: string = null;
      modified: string = null;
      created: string = null;
    };

    return { ...newCdoCustomerRequirement, ...cdoCustomerRequirement };
  }

}
